<template>
  <el-popover
    placement="bottom-end"
    trigger="click"
    width="240"
    popper-class="columns-control__popover"
  >
    <span slot="reference" class="columns-control__trigger sortbox">
      <i class="columns-control__icon" aria-hidden="true"></i>
      Columns ({{ visibleCount }}/{{ localColumns.length }})
    </span>
    <div class="columns-control__header">
      <span class="columns-control__title">Show columns</span>
      <a href="javascript:void(0)" class="columns-control__show-all" @click="showAll"
        >Show all</a
      >
    </div>
    <div class="columns-control__list">
      <el-checkbox
        v-for="col in localColumns"
        :key="col.prop"
        v-model="col.visible"
        class="columns-control__item"
        @change="emitChange"
        >{{ col.label }}</el-checkbox
      >
    </div>
  </el-popover>
</template>

<script>
// Show/hide table columns, persisted per browser under `storageKey` in localStorage. This
// component only tracks which column keys are visible and emits "change" with that list -
// the parent page owns the actual <el-table-column v-if="..."> bindings and column definitions,
// since Element UI's table columns are declared per-page, not driven off a shared config.
export default {
  name: "ColumnsControl",
  props: {
    columns: { type: Array, required: true }, // [{ prop, label, visible }]
    storageKey: { type: String, required: true }
  },
  data() {
    return {
      localColumns: this.columns.map(col => ({ ...col }))
    };
  },
  computed: {
    visibleCount() {
      return this.localColumns.filter(col => col.visible).length;
    }
  },
  created() {
    const saved = this.loadSaved();
    if (saved) {
      this.localColumns.forEach(col => {
        if (Object.prototype.hasOwnProperty.call(saved, col.prop)) {
          col.visible = saved[col.prop];
        }
      });
    }
    this.emitChange();
  },
  methods: {
    loadSaved() {
      try {
        const raw = window.localStorage.getItem(this.storageKey);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    persist() {
      try {
        const map = {};
        this.localColumns.forEach(col => {
          map[col.prop] = col.visible;
        });
        window.localStorage.setItem(this.storageKey, JSON.stringify(map));
      } catch (e) {
        // localStorage unavailable (private browsing, quota) - visibility just won't persist.
      }
    },
    showAll() {
      this.localColumns.forEach(col => {
        col.visible = true;
      });
      this.emitChange();
    },
    emitChange() {
      this.persist();
      this.$emit(
        "change",
        this.localColumns.filter(col => col.visible).map(col => col.prop)
      );
    }
  }
};
</script>

<style scoped>
.columns-control__trigger {
  display: inline-flex;
  align-items: center;
  column-gap: 6px;
  cursor: pointer;
}
.columns-control__icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid currentColor;
  border-radius: 2px;
  position: relative;
}
.columns-control__icon::before,
.columns-control__icon::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: currentColor;
}
.columns-control__icon::before {
  left: 33%;
}
.columns-control__icon::after {
  left: 66%;
}
</style>

<style>
.columns-control__popover {
  padding: 12px 16px;
}
.columns-control__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  margin-bottom: 4px;
  border-bottom: 1px solid #e6ebee;
}
.columns-control__title {
  font-weight: 700;
  color: #003448;
  font-size: 14px;
}
.columns-control__show-all {
  font-size: 13px;
  color: #10a3ae;
  text-decoration: none;
}
.columns-control__list {
  max-height: 320px;
  overflow-y: auto;
}
.columns-control__item {
  display: block;
  margin-left: 0 !important;
  padding: 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ColumnsControl.vue